import Vue from "vue";

export default {
	list({}, filter) {
		return Vue.api.post('role/list', {
			per_page: filter.per_page || 15,
			current_page: filter.current_page || 1
		})
	},
	create({}, data) {
		return Vue.api.post('role/', data)
	},
	update({dispatch}, data) {
		if (!data._id) {
			return dispatch('create', data)
		}

		return Vue.api.put('role/' + data._id, data)
	},
	delete({}, id) {
		return Vue.api.delete('role/' + id)
	},
	all({}, {}) {
		return Vue.api.get('role/all/get').then(list => {
			return list.filter(role => role.type !== 'client' && role.type !== 'guest' && role.type !== 'root')
		})
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/role/actions.js